import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, message, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import {showErrorNotification, showSuccessNotification} from "@/shared/utils/notify";
import {
    useDynamicEditFormConfig,
    useManageSubscription
} from "@/modules/action-flow/config/hooks/use-action-flow";

const DynamicFormConfigEditor: React.FC = () => {
    const { domain, subscriptionId } = useParams<{ domain: string; subscriptionId: string }>();
    const [configJson, setConfigJson] = useState('');
    const { config: initialConfig, isLoading, isError } = useDynamicEditFormConfig(domain!, subscriptionId!);
    const {setFormConfig} = useManageSubscription();

    useEffect(() => {

        if (initialConfig) {
            try {
                // const parsedConfig = initialConfig;
                // @ts-ignore
                setConfigJson(JSON.stringify(JSON.parse(initialConfig.config), null, 2));
            } catch (error) {
                console.error('Invalid JSON in initialConfig:', error);
                setConfigJson('');
            }
        }
    }, [initialConfig]);

    const handleSubmit = async () => {
        try {
            const config = JSON.parse(configJson);
            console.log("SUBMITING",config);
            await setFormConfig({
                domain: domain!,
                subscriptionId: subscriptionId!,
                data: JSON.stringify(config),
            });
            showSuccessNotification('Dynamic form configuration updated successfully');
        } catch (error) {
            console.error('Error updating configuration:', error);
            showErrorNotification('Failed to update dynamic form configuration');
        }
    };

    if (isLoading) return <Spin size="large" />;
    if (isError) return <div>Error loading configuration</div>;



    return (
        <div style={{ padding: '20px' }}>
            <Link to="/admin/action-flow/subscriptions">
                <Button icon={<ArrowLeftOutlined />} style={{ marginBottom: '20px' }}>
                    Back to Subscriptions
                </Button>
            </Link>
            <h1>Edit Dynamic Form Configuration</h1>
            <h2>Domain: {domain}, Subscription ID: {subscriptionId}</h2>
            <AceEditor
                mode="json"
                theme="github"
                onChange={setConfigJson}
                value={configJson}
                name="UNIQUE_ID_OF_DIV"
                editorProps={{ $blockScrolling: true }}
                setOptions={{
                    useWorker: false,
                    showLineNumbers: true,
                    tabSize: 2,
                }}
                style={{ width: '100%', height: '75vh', marginBottom: '20px' }}
            />
            <Button type="primary" onClick={handleSubmit} style={{ marginRight: '10px' }}>
                Update Configuration
            </Button>
            <Button onClick={() => setConfigJson(JSON.stringify(JSON.parse(initialConfig || '{}'), null, 2))}>
                Reset
            </Button>
        </div>
    );
};

export default DynamicFormConfigEditor;